import React from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import {BrowserRouter as Router} from "react-router-dom";

// import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// local files
import AllRoutes from './combinedRoutes'

// Import Haptik component 
import Haptik from "./components/HaptikChatICon/HaptikChatIcon";

//redux
import {Provider} from 'react-redux'
import {applyMiddleware, legacy_createStore as createStore} from 'redux'
import {rootReducer} from './store/Reducer'
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {PersistGate} from 'redux-persist/integration/react';
import {composeWithDevTools} from 'redux-devtools-extension';
import {thunk} from "redux-thunk"
//swiper
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { loadAnalytics } from './utils/analyticsLoader';

const persistConfig = {
    key: 'root',
    storage,
};
const middlewares = [thunk];

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, 
    applyMiddleware(...middlewares),
    // other store enhancers if any
);

const persistor = persistStore(store);

const routing = (
    // <ReactPWAInstallProvider enableLogging>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Router>
                <Haptik/>
                <AllRoutes/>
            </Router>
        </PersistGate>
    </Provider>

);

// ReactDOM.render(
// 	routing,
// 	document.getElementById('root')
// );


const container = document.getElementById('root');
// const initialLoader = container.querySelector('#initial-loader');
// if (initialLoader) {
//     initialLoader.remove();
// }

const root = createRoot(container);
root.render(routing);

// Load analytics after React renders
// requestIdleCallback(() => {
//   loadAnalytics();
// }, { timeout: 2000 });

if(window.requestIdleCallback){
    requestIdleCallback(() => {
        loadAnalytics();
    }, { timeout: 2000 });
} else {
    loadAnalytics();
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
